import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import configuration from "../../config";
import { db } from "../../firebase";
import { ref, onValue } from "firebase/database";
import Loader from "../../components/Loader/Loader";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { reactLocalStorage } from "reactjs-localstorage";

const Marker = ({ driver, onClick }) => (
  <div onClick={() => onClick(driver)} style={{ cursor: "pointer" }}>
    <img src="/image/pin.png" style={{ width: 40 }} alt="marker" />
  </div>
);

const InfoPopup = ({ data }) => (
  <div
    style={{
      position: "relative",
      background: "#f3f4f6", // Tailwind's gray-100
      padding: "14px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      maxWidth: "280px",
      minWidth: "220px",
      fontSize: "14px",
      lineHeight: "1.4",
      border: "1px solid #e5e7eb", // Tailwind's gray-200
    }}
  >
    {data ? (
      <>
        <p>
          <strong>Trip ID:</strong> {data.trip_id}
        </p>
        <p>
          <strong>Driver:</strong> {data.driver_name}
        </p>
        <p>
          <strong>Passenger:</strong> {data.passenger_name}
        </p>
        <p>
          <strong>Pickup:</strong> {data.pickup_location}
        </p>
        <p>
          <strong>Dropoff:</strong> {data.dropoff_location}
        </p>
      </>
    ) : (
      <p>Loading...</p>
    )}
  </div>
);

function View() {
  const [allDrivers, setAllDrivers] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [driverType, setDriverType] = useState(null);
  const [tripDetails, setTripDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [rideOption, setRideOption] = useState("");
  const [tripId, setTripId] = useState("");
  const [driverId, setDriverId] = useState("");
  const [passengerId, setPassengerId] = useState("");
  const [tripType, setTripType] = useState("");
  const [adminType, setAdminType] = useState("");

  const defaultCenter = {
    lat: 23.0260094693156,
    lng: 72.55570555792589,
  };
  const zoom = 12;

  const notificationMethods = [
    { id: "All", title: "All" },
    { id: "Online", title: "Online" },
    { id: "Offline", title: "Offline" },
  ];

  const notificationMethods2 = [
    { id: "RIDE", title: "Ride" },
    { id: "RENTAL", title: "Rental" },
    { id: "OUT_STATION", title: "Outstation" },
  ];

  useEffect(() => {
    const master_user_type = reactLocalStorage.get("user_type");
    setAdminType(master_user_type);
    defaultDrivers();
  }, []);

  const defaultDrivers = () => {
    setIsLoading(true);
    configuration
      .getAPI({ url: "driver/live-trips-driver-list", params: {} })
      .then((data) => {
        setIsLoading(false);
        if (data.status === 200) {
          const driverIds = data.payload || [];
          setAllDrivers(driverIds);

          const driversRef = ref(db, "drivers");
          const unsubscribe = onValue(driversRef, (snapshot) => {
            const firebaseData = snapshot.val();
            if (firebaseData) {
              const filteredDrivers = Object.keys(firebaseData)
                .filter((id) => driverIds.includes(id))
                .map((id) => ({
                  id,
                  ...firebaseData[id],
                }));
              setDrivers(filteredDrivers);
            }
          });

          return () => unsubscribe(); // cleanup on unmount
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        // return toast.error(error.message);
      });
  };
  const handleMarkerClick = async (driver) => {
    // setIsLoading(true);
    setSelectedDriver(driver);
    // setTripDetails(null); // reset previous data
    configuration
      .getAPI({
        url: "trip/live-trip-detail",
        params: { trip_id: driver.trip_id },
      })
      .then((data) => {
        // setIsLoading(false);
        if (data.status === 200) {
          setTripDetails({
            trip_id: driver.trip_id,
            driver_name: data.payload.driver_name,
            passenger_name: data.payload.passenger_name,
            pickup_location: data.payload.pickup_location,
            dropoff_location: data.payload.dropoff_location,
          });
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
        // return toast.error(error.message);
      });
    // }
  };

  const handleFilter = () => {
    setIsLoading(true);
    const filters = {
      driverType,
      rideOption,
      tripId,
      driverId,
      passengerId,
      tripType,
    };
    console.log("Selected Filters:", filters);
    // Call your API or filter logic here
    configuration
      .postAPI({ url: "trip/live-trip-filter", params: filters })
      .then((data) => {
        console.log(data);
        setIsLoading(false);
        if (data.status === 200) {
          const driverIds = data.payload || [];
          setAllDrivers(driverIds);

          const driversRef = ref(db, "drivers");
          const unsubscribe = onValue(driversRef, (snapshot) => {
            const firebaseData = snapshot.val();
            if (firebaseData) {
              const filteredDrivers = Object.keys(firebaseData)
                .filter((id) => driverIds.includes(id))
                .map((id) => ({
                  id,
                  ...firebaseData[id],
                }));
              setDrivers(filteredDrivers);
            }
          });

          return () => unsubscribe(); // cleanup on unmount
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  };
  const handleDriverFilter = (type) => {
    setIsLoading(true);
    configuration
      .getAPI({ url: "driver/live-trips-driver-list", params: {} })
      .then((data) => {
        setIsLoading(false);
        if (data.status === 200) {
          const driverIds = data.payload || [];
          setAllDrivers(driverIds);

          const driversRef = ref(db, "drivers");
          const unsubscribe = onValue(driversRef, (snapshot) => {
            const firebaseData = snapshot.val();
            if (firebaseData) {
              const filteredDrivers = Object.keys(firebaseData)
                .filter((id) => {
                  const driver = firebaseData[id];

                  const isIdIncluded = driverIds.includes(id);
                  const matchesStatus =
                    type === "All" ||
                    (type === "Online" && driver.status === "online") ||
                    (type === "Offline" && driver.status === "offline");

                  return isIdIncluded && matchesStatus;
                })
                .map((id) => ({
                  id,
                  ...firebaseData[id],
                }));

              setDrivers(filteredDrivers);
            }
          });

          return () => unsubscribe(); // cleanup on unmount
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const handleClear = () => {
    defaultDrivers();
    setDriverType("");
    setRideOption("");
    setTripId("");
    setDriverId("");
    passengerId("");
    tripType("");
  };
  return (
    <div className="bg-gray-50 flex flex-col justify-center">
      <Loader isOpen={isLoading} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        theme="colored"
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="grid grid-cols-1 md:grid-cols-4 ">
        <div className=" py-4 px-4 shadow-lg bg-white">
          <h3 className="font-bold text-lg mb-5">Live Trips</h3>

          {/* Drivers */}
          {adminType === "company" ? (
            <div>
              <label className="text-base font-medium text-gray-900">
                Driver
              </label>
              <fieldset className="mt-4">
                <legend className="sr-only">Notification method</legend>
                <div className="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  {notificationMethods.map((notificationMethod) => (
                    <div
                      key={notificationMethod.id}
                      className="flex items-center"
                    >
                      <input
                        id={notificationMethod.id}
                        name="notification-method"
                        type="radio"
                        // defaultChecked={notificationMethod.id === "All"}
                        value={notificationMethod.id}
                        checked={driverType === notificationMethod.id}
                        onChange={(e) => handleDriverFilter(e.target.value)}
                        className="focus:ring-indigo-600 h-4 w-4 text-indigo-600 border-gray-300"
                      />
                      <label
                        htmlFor={notificationMethod.id}
                        className="ml-3 block text-basefont-medium text-gray-700"
                      >
                        {notificationMethod.title}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
          ) : (
            ""
          )}
          {/* Ride Options */}
          <div>
            <p className="text-base font-medium text-gray-900 mt-5">
              Trip Options
            </p>
            <select
              id="location"
              name="location"
              className="w-full mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-600 focus:border-indigo-600 sm:text-baserounded-md"
              defaultValue="Canada"
              value={rideOption}
              onChange={(e) => setRideOption(e.target.value)}
            >
              <option>Select Trip Option</option>
              <option value="VRO165209169556">Mini Cab</option>
              <option value="VRO165209173111">Sedan</option>
              <option value="VRO165209176434">SUV</option>
            </select>
          </div>
          <div>
            <p className="text-base font-medium text-gray-900 mt-5">
              By Trip ID
            </p>
            <input
              type="email"
              name="email"
              id="email"
              value={tripId}
              onChange={(e) => setTripId(e.target.value)}
              className="mt-1 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 block w-full sm:text-baseborder-gray-300 rounded-md"
              placeholder="Trip ID"
            />
          </div>
          <div>
            <p className="text-base font-medium text-gray-900 mt-5">
              By Driver ID
            </p>
            <input
              type="email"
              name="email"
              id="email"
              value={driverId}
              onChange={(e) => setDriverId(e.target.value)}
              className="mt-1 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 block w-full sm:text-baseborder-gray-300 rounded-md"
              placeholder="Driver ID"
            />
          </div>
          <div>
            <p className="text-base font-medium text-gray-900 mt-5">
              By Passenger ID
            </p>
            <input
              type="email"
              name="email"
              id="email"
              value={passengerId}
              onChange={(e) => setPassengerId(e.target.value)}
              className="mt-1 shadow-sm focus:ring-indigo-600 focus:border-indigo-600 block w-full sm:text-baseborder-gray-300 rounded-md"
              placeholder=" Passenger ID"
            />
          </div>

          <div>
            <p className="text-base font-medium text-gray-900 mt-5">
              Trip Type
            </p>
            <fieldset className="mt-4">
              <div className="grid grid-cols-1 gap-4">
                {notificationMethods2.map((notificationMethod) => (
                  <div
                    key={notificationMethod.id}
                    className="flex items-center"
                  >
                    <input
                      id={notificationMethod.id}
                      name="notification-method"
                      type="radio"
                      // defaultChecked={notificationMethod.id === "email"}
                      value={notificationMethod.id}
                      checked={tripType === notificationMethod.id}
                      onChange={(e) => setTripType(e.target.value)}
                      className="focus:ring-indigo-600 h-4 w-4 text-indigo-600 border-gray-300"
                    />
                    <label
                      htmlFor={notificationMethod.id}
                      className="ml-3 block text-basefont-medium text-gray-700"
                    >
                      {notificationMethod.title}
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
          </div>
          <div className="pt-5">
            <button
              type="button"
              onClick={handleFilter}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto"
            >
              Filter
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto"
            >
              Clear
            </button>
          </div>
        </div>
        <div className="col-span-3" style={{ height: "100vh", width: "100%" }}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: configuration.googleAPIKey }}
            defaultCenter={defaultCenter}
            defaultZoom={zoom}
            onClick={() => {
              setSelectedDriver(null);
              setTripDetails(null);
            }}
            // options={{
            //     styles: exampleMapStyles
            // }}
          >
            {drivers.map((driver) => (
              <Marker
                key={driver.id}
                lat={parseFloat(driver.latitude)}
                lng={parseFloat(driver.longitude)}
                driver={driver}
                onClick={handleMarkerClick}
              />
            ))}

            {selectedDriver && (
              <InfoPopup
                lat={parseFloat(selectedDriver.latitude)}
                lng={parseFloat(selectedDriver.longitude)}
                data={tripDetails}
              />
            )}
          </GoogleMapReact>
        </div>
      </div>
    </div>
  );
}

View.propTypes = {
  history: PropTypes.func,
};

View.defaultProps = {
  history: () => {},
};

export default View;
